'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactScroll = require('react-scroll');
var _components = require('../../components');

var _generatePropertyDataForPublish = require('../../helpers/generatePropertyDataForPublish');var _generatePropertyDataForPublish2 = _interopRequireDefault(_generatePropertyDataForPublish);

var _PublishPropertyForm = require('./PublishPropertyForm.scss');var styles = _interopRequireWildcard(_PublishPropertyForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var SubmitBlock = function (_Component) {_inherits(SubmitBlock, _Component);function SubmitBlock() {var _temp, _this, _ret;_classCallCheck(this, SubmitBlock);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.scrollTop = function (event) {event.preventDefault();
      _reactScroll.scroller.scrollTo('anchor-top', {
        duration: 500,
        smooth: true,
        offset: -500 });

    }, _this.






















    previewHandler = function (event) {
      event.preventDefault();
      _this.openPreviewModal();
    }, _this.

    errorHandler = function (handleFunction) {return _this.props.errors ? _this.props.handleSubmit(handleFunction) : handleFunction;}, _temp), _possibleConstructorReturn(_this, _ret);}SubmitBlock.prototype.openPreviewModal = function openPreviewModal() {var _this2 = this;var isPreview = true;var _props = this.props,fields = _props.fields,userData = _props.userData,place = _props.place;var parameters = (0, _generatePropertyDataForPublish2.default)(fields, this.props.config, userData, isPreview, false, place);var images = fields.images && fields.images.length ? _components.UploadAssetWidget.modifyImagesForPreview(fields.images) : [];parameters.images = images;parameters.has_photos = !!images.length;parameters.thumbnail = images.length ? images[0].thumbnail : null;parameters.isPreview = isPreview;parameters.id = this.props.propertyId;if (userData && userData.is_agent && userData.profile_img) {parameters.contacts.primary.realtor_image = userData.profile_img;}setTimeout(function () {return _this2.props.openPreviewDetailsPopup(parameters);});};SubmitBlock.prototype.

  render = function render() {
    var publishTitle = this.props.paymentIsRequired ? 'payAndPublish' : 'publish';
    var submitTitle = this.props.isEdit ? 'updateProperty' : publishTitle;

    return (
      _react2.default.createElement('div', { className: styles.buttonsRow },
        _react2.default.createElement(_components.OMSubmitButton, {
          title: this.props.translate('sections', submitTitle),
          activeSpinner: this.props.submitting || this.props.uploadInProgress || this.props.iframeLoading,
          disabled: this.props.submitting || this.props.uploadInProgress,
          disableSubmit: this.props.paymentIsRequired,
          onClick: this.errorHandler(this.props.sendPaymentRequest) }),







        _react2.default.createElement(_components.OMUpButton, { scrollTop: this.scrollTop })));


  };return SubmitBlock;}(_react.Component);exports.default = SubmitBlock;


SubmitBlock.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  fields: _propTypes2.default.object.isRequired,
  isEdit: _propTypes2.default.bool,
  submitting: _propTypes2.default.bool,
  uploadInProgress: _propTypes2.default.bool,
  openPreviewDetailsPopup: _propTypes2.default.func.isRequired,
  errors: _propTypes2.default.object,
  handleSubmit: _propTypes2.default.func.isRequired,
  config: _propTypes2.default.object,
  propertyId: _propTypes2.default.string,
  userData: _propTypes2.default.object,
  paymentIsRequired: _propTypes2.default.bool.isRequired,
  sendPaymentRequest: _propTypes2.default.func.isRequired,
  iframeLoading: _propTypes2.default.bool.isRequired,
  place: _propTypes2.default.object };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishForm/SubmitBlock.js
// module id = 3024
// module chunks = 0